import { render, staticRenderFns } from "./CreateDashboard.vue?vue&type=template&id=9646a9a8&scoped=true&"
import script from "./CreateDashboard.vue?vue&type=script&lang=js&"
export * from "./CreateDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CreateDashboard.vue?vue&type=style&index=0&id=9646a9a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9646a9a8",
  null
  
)

export default component.exports